const isDev = location.port

export default {
  cyqq: isDev ? '/cyqq' : 'https://c.y.qq.com',
}



// WEBPACK FOOTER //
// ./src/store/api.js